module.exports = __webpack_public_path__ + "58cd789.woff2";